import React from 'react'
import { useContact, ContactProps } from './useContact'
import styles from './Contact.module.scss'
import TitleSection from 'components/TitleSection/TitleSection'

const Contact: React.FC<ContactProps> = (props: ContactProps) => {
  const {
    name,
    email,
    subject,
    message,
    isLoading,
    isSendContactMessageSuccess,
    setName,
    setEmail,
    setSubject,
    setMessage,
    onSubmit,
  } = useContact(props)

  return (
    <section id='contact' className={styles.contact}>
      <TitleSection
        title='Contact'
        descriptionTitle='Contact'
        description='We’re just a message away.'
      />

      <div className='container'>
        <div className={styles['contact-wrapper']}>
          <div className={styles['contact-info-panel']}>
            <div className={styles['contact-info-header']}>
              <h3>Contact Information</h3>
              <p>
                Have a question or need help with your account? Reach out to us
                — we’re always happy to assist.
              </p>
            </div>

            <div className={styles['contact-info-cards']}>
              <div className={styles['info-card']}>
                <div className={styles['icon-container']}>
                  <i className='bi bi-pin-map-fill'></i>
                </div>
                <div className={styles['card-content']}>
                  <h4>Our Location</h4>
                  <p>Beirut, Lebanon</p>
                </div>
              </div>

              <div className={styles['info-card']}>
                <div className={styles['icon-container']}>
                  <i className='bi bi-envelope-open'></i>
                </div>
                <div className={styles['card-content']}>
                  <h4>Email Us</h4>
                  <p>
                    <a href='mailto:support@bytebuffetbox.com'>
                      support@bytebuffetbox.com
                    </a>
                  </p>
                </div>
              </div>

              <div className={styles['info-card']}>
                <div className={styles['icon-container']}>
                  <i className='bi bi-telephone-fill'></i>
                </div>
                <div className={styles['card-content']}>
                  <h4>Call Us</h4>
                  <p>
                    <a href='tel:+96176951367'>+961 76 951 367</a>
                  </p>
                </div>
              </div>
            </div>

            <div className={styles['social-links-panel']}>
              <h5>Follow Us</h5>
              <div className={styles['social-icons']}>
                <a
                  href='https://www.instagram.com/bytebuffetbox/'
                  target='_blank'
                  rel='noreferrer'
                >
                  <i className='bi bi-instagram'></i>
                </a>
                <a
                  href='https://www.facebook.com/bytebuffetbox'
                  target='_blank'
                  rel='noreferrer'
                >
                  <i className='bi bi-facebook'></i>
                </a>
                <a
                  href='https://www.tiktok.com/@bytebuffetbox'
                  target='_blank'
                  rel='noreferrer'
                >
                  <i className='bi bi-tiktok'></i>
                </a>
              </div>
            </div>
          </div>

          <div className={styles['contact-form-panel']}>
            <div className={styles['form-container']}>
              <h3>Send Us a Message</h3>
              <p>
                Got something on your mind? Fill out the form below and we’ll
                get back to you as soon as possible.
              </p>

              <form className={styles['contact-form']} onSubmit={onSubmit}>
                <div className={`${styles['form-floating']} mb-3`}>
                  <input
                    type='text'
                    className={`form-control ${styles['form-control']}`}
                    id='nameInput'
                    name='name'
                    value={name}
                    placeholder='Full Name'
                    onChange={(e) => setName(e.target.value)}
                    autoComplete='off'
                    required
                  />
                  <label htmlFor='nameInput'>Full Name</label>
                </div>

                <div className={`${styles['form-floating']} mb-3`}>
                  <input
                    type='email'
                    className={`form-control ${styles['form-control']}`}
                    id='emailInput'
                    name='email'
                    value={email}
                    placeholder='Email Address'
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete='off'
                    required
                  />
                  <label htmlFor='emailInput'>Email Address</label>
                </div>

                <div className={`${styles['form-floating']} mb-3`}>
                  <input
                    type='text'
                    className={`form-control ${styles['form-control']}`}
                    id='subjectInput'
                    name='subject'
                    value={subject}
                    placeholder='Subject'
                    onChange={(e) => setSubject(e.target.value)}
                    autoComplete='off'
                    required
                  />
                  <label htmlFor='subjectInput'>Subject</label>
                </div>

                <div className={`${styles['form-floating']} mb-3`}>
                  <textarea
                    className={`form-control ${styles['form-control']}`}
                    id='messageInput'
                    name='message'
                    value={message}
                    rows={5}
                    placeholder='Your Message'
                    onChange={(e) => setMessage(e.target.value)}
                    style={{ height: 150 }}
                    required
                  ></textarea>
                  <label htmlFor='messageInput'>Your Message</label>
                </div>

                <div className='my-3'>
                  <div
                    className={styles.loading}
                    style={{ display: isLoading ? 'block' : 'none' }}
                  ></div>
                  <div className={styles['error-message']}></div>
                  <div
                    className={styles['sent-message']}
                    style={{
                      display: isSendContactMessageSuccess ? 'block' : 'none',
                    }}
                  >
                    Your message has been sent. Thank you!
                  </div>
                </div>

                <div className='d-grid'>
                  <button
                    type='submit'
                    className={styles['btn-submit']}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Please wait...' : 'Send Message'}
                    <i className='bi bi-send-fill ms-2'></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Contact
